import React from "react";
import {Button, withStyles} from '@material-ui/core';

const MyButton = withStyles({
    root: {
        margin: ({margin}) => margin ? margin : '0px',
        borderRadius: ({borderradius}) => borderradius ? borderradius : '1em',
        background: ({background}) => background ? background : 'transparent',
        width: ({width}) => width ? width : ''
    },
    label: {
        textTransform: 'capitalize',
        fontSize: ({fontSize}) => fontSize ? fontSize : 14,
        color: ({textcolor}) => textcolor ? textcolor : "var(--black)",
        fontWeight: 'bold',
        background: 'transparent',
        "&:hover": {
            color: ({hover}) => hover ? hover : "var(--gray_4)",
        }
    }
})(Button)

export default function IconTitleButton(props) {

    function getHorizontalContent() {
        if (props.direction && props.direction === "rtl") {
            return <div className="clickable fullWidth">
                {(props.badgenumber && props.badgenumber > 0) &&
                <div className="smallCircle smallIcon_1 whiteColor smallText"
                     style={{position: "absolute", top: "-0.5em", right: "-0.5em"}}>
                    {props.badgenumber}
                </div>
                }
                <table>
                    <tbody>
                    <tr>
                        {props.showbar && props.showbar === "true" &&
                        <td style={{width: "1%", backgroundColor: props.barcolor ? props.barcolor : "blue"}}/>
                        }
                        {props.title &&
                        <td style={{width: "90%"}}>
                            <label
                                className={props.fontSize ? props.fontSize + " clickable"
                                    : "mediumTextBold clickable"}
                                style={{
                                    float: "right",
                                    whiteSpace: props.whiteSpace ? props.whiteSpace : "nowrap"
                                }}>
                                {props.title}
                            </label>
                        </td>
                        }
                        <td style={{width: "10%"}}>
                            {props.icon}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        } else {
            return <div className="clickable fullWidth">
                {(props.badgenumber && props.badgenumber > 0) &&
                <div className="smallCircle smallIcon_1 whiteColor smallText"
                     style={{position: "absolute", top: "-0.5em", right: "-0.5em"}}>
                    {props.badgenumber}
                </div>
                }
                <table className="clickable" style={{width: "100%"}}>
                    <tbody>
                    <tr>
                        <td style={{width: "10%"}}>
                            {props.icon}
                        </td>
                        <td className="clickable" style={{width: "90%"}}>
                            <label
                                className={props.fontSize ? props.fontSize + " clickable"
                                    : "mediumTextBold clickable"}
                                style={{
                                    float: "right",
                                    whiteSpace: props.whiteSpace ? props.whiteSpace : "nowrap"
                                }}>
                                {props.title}
                            </label>
                        </td>
                        {props.hasaftericon && props.hasaftericon === "true" &&
                        <td style={{width: "10%"}}>
                            {props.afterIcon}
                        </td>
                        }
                    </tr>
                    </tbody>
                </table>
            </div>
        }
    }

    function getVerticalContent() {
        return <div className="center clickable" style={{height: props.height ? props.height : "100%"}}>
            <div>
                <div>
                    {props.icon}
                </div>
                <label className={props.fontSize ? props.fontSize + " clickable"
                    : "mediumTextBold clickable"}
                       style={{
                           whiteSpace: props.whiteSpace ? props.whiteSpace : "nowrap"
                       }}>
                    {props.title}
                </label>
            </div>
            {(props.badgenumber && props.badgenumber > 0) &&
            <div className="smallCircle smallIcon_1 whiteColor smallText"
                 style={{position: "absolute", top: "-0.5em", right: "-0.5em"}}>
                {props.badgenumber}
            </div>
            }
        </div>
    }

    return (
        <MyButton style={{
            backgroundColor: props.backgroundColor ? props.backgroundColor : "var(--transparent)"
        }} {...props}>
            {(props.isvertical && props.isvertical === "true") ?
                getVerticalContent() : getHorizontalContent()}
        </MyButton>
    )
}